import { compareDesc } from 'date-fns';
import { groupBy } from 'app/agriculture/utils';
import { TaskRow } from 'app/agriculture/routes/Tasks/TaskList/components/TaskRow/TaskRow';
import './TaskCategoryList.scss';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

interface TaskCategoryListProps {
    tasks: Task[];
}
export function TaskCategoryList({ tasks }: TaskCategoryListProps) {
    const groupedByCategory = groupBy(tasks, 'category');

    return (
        <div className="TaskCategoryList">
            {groupedByCategory.map((groupedTasks) => (
                <div
                    key={groupedTasks[0]?.category}
                    className="TaskCategoryListGroup"
                    data-testid="task-category"
                >
                    <h5 className="TaskCategoryListGroup__title" data-testid="task-category-title">
                        {groupedTasks[0]?.category}
                    </h5>
                    {groupedTasks
                        .sort((a, b) => compareDesc(a.updatedAt, b.updatedAt))
                        .map((task) => (
                            <TaskRow key={[task.id, task.title].join(' - ')} task={task} />
                        ))}
                </div>
            ))}
        </div>
    );
}
